/**
 * @file The display label of every stage a project query returns, keyed by
 * `AnalyticsProjectStage`. Consumers: the Projects tab's STAGE tags, its FORMS
 * column, which abbreviates each open stage by the first letter of its label
 * ("Q · B · O · R"), the Pipeline by stage card, and the report run renderers,
 * which name a stage list ("Quote", "Buy") by the same words. The `Record`
 * type fails the build when a stage is added without a label.
 */
import type { AnalyticsProjectStage } from './Analytics.NamedQuery.types';

export const ANALYTICS_PROJECT_STAGE_LABELS: Record<AnalyticsProjectStage, string> = {
  InDesign: 'InDesign',
  Lost: 'Lost',
  Complete: 'Complete',
  quote: 'Quote',
  buy: 'Buy',
  order: 'Order',
  reconciliation: 'Reconciliation',
};
